<style>
.top-right-login.hdr-btn {
  padding: 0 0 15px;
}
.top-right-login.hdr-btn a.login,
.top-right-login.hdr-btn a.event-List {
  font-size: 18px;
  padding-right: 0 !important;
  margin-left: 25px;
  cursor: pointer;
  background-position: left center;
}
.left-logo {
  width: 100%;
}
.event-box-list-wrapper .ev-box {
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
}
section.event-box-list-wrapper {
  margin-top: 25px;
}
</style>

<template>
  <div class>
    <!-- <header id="divHeader" class="header-navbar sticky-top p-0">
      <div class="container-fluid p-0">
        <div class="row">
          <div class="col-md-12">
            <div id="divBanner" class="d-flex align-items-center justify-content-between">

              <img id="imgBanner" v-bind:src="BannerURL" alt="e2m" />

            </div>
          </div>
        </div>
      </div>
    </header>-->

    <!--=== Header Start ===-->
    <header class="header-navbar sticky-top">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 px-0">
            <div class="d-flex align-items-center justify-content-between">
              <div class="left-logo">
                <a href>
                  <img id="imgBanner" v-bind:src="BannerURL" alt="e2m" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="page-effect RegEvent-wrapper">
      <section class="reg-event-banner text-center">
        <h1>Select an Event to Register</h1>
      </section>
      <!--=== Search Start ===-->
      <!-- <section class="reg-event-search">
      <div class="container">
        <div class="row">
          <div class="col-md-10 mx-auto search-wrapper p-4">
            <div class="row m-0">
              <div class="col-md-7 px-lg-2">
                <div class="search_event_box position-relative">
                  <input id type="text" placeholder="Search events" />
                  <button class="sub-btn" type="submit">Search</button>
                </div>
              </div>
              <div class="col-md-3 px-lg-2">
                <div class="search-date position-relative">
                  <input type="text" placeholder="Filter by date" id="datetimepicker1" />
                </div>
              </div>
              <div class="col-md-2 px-lg-2">
                <div class="search-button-area full-height">
                  <button class="event_search full-height">Search</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </section>-->
      <!--=== Search End ===-->
      <!-- <section id="alleventSec" class="all-events-wrapper eventlistnew-wraper">
      <h3 id="selTitle" class="pagetitle text-center py-4 clsDynamicColor">Please select an event</h3>

      <div class="container">
        <div class="row" id="EventList">
          <div
            v-for="events in EventsData"
            v-bind:key="events.id"
            v-on:click="selectEvent(events.id);"
            class="col-sm-6 col-xs-12 item filterPanel"
            v-bind:id="events.id"
            style="cursor:pointer;"
          >
            <div
              class="all-events-block equalhei clearfix redsn-evnts-col"
              style="background: rgb(255, 255, 255);"
            >
              <a href="#" class="nav-link tab-link">
                <figure class="events-logo">
                  <img v-bind:src="events.EventLogo" v-bind:alt="events.Name" />
                </figure>
                <article>
                  <h3 style="color: rgb(0, 0, 0);">{{events.Name}}</h3>
                  <h5
                    class="ico-calender-sm"
                    style="color: rgb(0, 0, 0);"
                  >{{events.EventStartDateString}} - {{events.EventEndDateString}}</h5>
                </article>
                <div id="tags" class="d-flex flex-wrap align-items-stretch"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
      </section>-->

      <section class="event-box-list-wrapper">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="top-right-login hdr-btn text-right">
                <a v-on:click="goForLogin" class="login">Login</a>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              v-for="events in EventsData"
              v-bind:key="events.id"
              v-on:click="selectEvent(events.id,events.Name);"
              v-bind:id="events.id"
              class="col-md-4"
            >
              <div class="ev-box border mb-3">
                <div class="ev-box-image-hld">
                  <img v-bind:src="events.EventLogo" v-bind:alt="events.Name" />
                  <h4 class="px-3 mt-3">{{events.Name}}</h4>
                </div>
                <div class="ev-box-des-hld p-3">
                  <!--<h6>
                  <span>Hosted By:</span>
                  {{ClientName}}
                  </h6>-->
                  <div class="top-right-login">
                    <a
                      href
                      class="event-List"
                    >{{events.EventStartDateString}} to {{events.EventEndDateString}} &nbsp; {{events.EventTimezone}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
// import HelloWorld from "@/components/HelloWorld.vue";
// import Router from "vue-router";
// import firebase from "firebase";
import db from "../components/firebaseInit";
// import firebase from "firebase";
// import axios from "axios";
// import store from "../store";
import router from "../router";
import jQuery from "jquery";
let $ = jQuery;
var self;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";

Vue.use(VueMoment, {
  moment,
});
export default {
  data() {
    return {
      EventsData: [],
      clientID: this.$route.query.c, //this.$store.getters.getClient[0].id,
      BannerURL: "",
    };
  },
  mounted() {
    self = this;
    // window.Tawk_API.onLoad = function () {
    //   window.Tawk_API.hideWidget();
    // };
    /* $("#alleventSec").css("background-size", "cover");
    $("#alleventSec").css("background-color", "none");
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    $("#alleventSec").css(
      "background-image",
      "url(" + obj.branding[0].bg2 + ")"
    );
    $("#alleventSec").css("background-size", "100%");
    //alert(obj.Branding[0].banner)
    $("#imgBanner").attr("src", obj.branding[0].banner);

    $(".clsDynamicColor").css("color", obj.branding[0].bodyTextColor);*/
    debugger;
    $("#topmenu").hide();
    $("#leftmenu").hide();
    // var obj = JSON.parse(window.localStorage.getItem("my-app"));
    // this.BannerURL = obj.branding[0].banner;
    /*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
    self.clientID = this.$route.query.c;
    db.collection("OA_UAT")
      .doc("ClientList")
      .collection("Clients")
      .doc(self.clientID)
      .get()
      .then(function (doc) {
        var data = doc.data();
        console.log(data);
        debugger;
        self.clientLogoUrl = data.LoginAssets.logo;
        self.ClientName = data.ClientName;
        self.clientProfile = data.Company;
        self.BannerURL = data.EventListAssets.banner2048x88;
      });
    /*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

    $("#imgBanner").attr("src", self.BannerURL);

    this.EventsData = [];
    this.displayEvents();
    $(document).attr("title", "E2M.live OnAir");
  },
  methods: {
    displayEvents() {
      debugger;
      this.pageIndex++;
      var listRef = db
        .collection("OA_UAT/ClientList/Clients")
        .doc(self.clientID)
        .collection("Events");

      listRef
        //.where("IsPublished", "==", true)
        .where("AllowRegistration", "==", true)
        .where("EventTypeId", "==", 2)
        //.get()
        .onSnapshot((querySnapshot) => {
          this.EventsData = [];
          debugger;
          if (querySnapshot.docs.length > 0) {
            querySnapshot.forEach((doc) => {
              var data = doc.data();
              /* this.EventsData.push({
                id: doc.id,
                Name: data.EventFullName,
                EventLogo: data.EventLogo,
                EventStartDate: data.EventStartDate,
                EventEndDate: data.EventEndDate,
                EventCollectionName: data.EventCollectionName,
                EventTypeId: data.EventTypeId,
                EventTimezone: data.TimeZone,
                EventStartDateString: self.formatDate(data.EventStartDate),
                EventEndDateString: self.formatDate(data.EventEndDate)
              });*/
              var obj = new Object();
              obj.id = doc.id;
              obj.Name = data.EventFullName;
              obj.EventLogo = data.EventLogo;
              // obj.EventStartDate = data.EventStartDate;
              // obj.EventEndDate = data.EventEndDate;
              obj.EventCollectionName = data.EventCollectionName;
              obj.EventTypeId = data.EventTypeId;
              obj.EventTimezone = moment.tz.guess(); //data.TimeZone;
              //-------------------------------------------------------------------------------------------
              /* var mZone = moment.tz.guess();
              //obj.EventStartDateString = self.formatDate(data.EventStartDate);
              if (data.TimeZone != mZone) {
                var EventStartDate = self.formatDateTimeZoneWise(
                  data.EventStartDate
                );
                var momnt = moment.tz(EventStartDate, data.TimeZone);
                var strtDate = momnt.clone().tz(moment.tz.guess());
                obj.EventStartDateString = self.GetActualDateFormat(
                  strtDate.format()
                );
              } else {
                obj.EventStartDateString = self.formatDate(data.EventStartDate);
              }*/
              var dateFormat = require("dateformat");

              var dtstrt = new Date(data.EventStartDate.seconds * 1000);
              obj.EventStartDateString = dateFormat(dtstrt, "mmm dd, hh:MM TT");
              // obj.EventStartDateString = moment(dtstrt).format(
              //   " MMMM Do, h:mm a"
              // );
              //self.formatDate(data.EventStartDate);
              //------------------------------------------------------------------------------------------------
              /*if (data.TimeZone != mZone) {
                // obj.EventEndDateString = self.formatDate(data.EventEndDate);
                var EventEndDate = self.formatDateTimeZoneWise(
                  data.EventEndDate
                );
                var momnt2 = moment.tz(EventEndDate, data.TimeZone);
                var endDate = momnt2.clone().tz(moment.tz.guess());
                obj.EventEndDateString = self.GetActualDateFormat(
                  endDate.format()
                );
              } else {
                obj.EventEndDateString = self.formatDate(data.EventEndDate);
              }*/
              var dtend = new Date(data.EventEndDate.seconds * 1000);
              obj.EventEndDateString = dateFormat(dtend, "mmm dd, hh:MM TT"); // self.formatDate(data.EventEndDate);
              //------------------------------------------------------------------------------------------------
              this.EventsData.push(obj);
            });
          }
        });
      // .catch(error => {
      //   alert(error);
      //   // console.log("Error getting documents: ", error);
      // });
    },
    GetActualDateFormat: function (actualDt) {
      var dt = actualDt.split("T");
      var oDt = new Date(dt[0]).toDateString();

      var oTt = dt[1];
      var arrDate = oDt.split(" ");
      var accDate = arrDate[1] + " " + arrDate[2];

      var arrtime = oTt.split(":");
      var accTime = arrtime[0] + ":" + arrtime[1];

      var fullStartDate = accDate + " " + accTime;
      return fullStartDate;
    },
    formatDateTimeZoneWise: function (seconds) {
      var dateString = "";
      try {
        var dt = new Date(seconds.seconds * 1000);
        debugger;

        var hrs = dt.getHours();
        hrs = hrs == 0 ? "00" : hrs;
        if (hrs != "00" && parseInt(hrs) < 10) {
          hrs = "0" + hrs;
        }

        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }

        var mnths = dt.getMonth();
        var accurateMon = mnths + 1;
        if (parseInt(accurateMon) < 10) {
          accurateMon = "0" + accurateMon;
        }

        dateString +=
          dt.getFullYear() +
          "-" +
          accurateMon +
          "-" +
          dt.getDate() +
          " " +
          hrs +
          ":" +
          minutes;

        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    selectEvent: function (eventId, evntName) {
      debugger;
      // router.push({
      //   path: "/openReg",
      //   query: { sid: eventId }
      // });
      //var obj = JSON.parse(window.localStorage.getItem("my-app"));
      console.log("clientdId:- " + self.clientID);
      var collection = self.clientID + eventId;

      // var str = evntName.replace(/ +(?= )/g, "_");
      // var str = evntName
      //   .replace(" ", "_")
      //   .replace(" ", "_")
      //   .replace(" ", "_")
      //   .replace("%20", "_")
      //   .replace("%20", "_")
      //   .replace("%20", "_")
      //   .replace("%20", "_");

      var str = evntName.replace(/ /g, "_");
      var str2 = str.replace(/%20/g, " ");

      router.push({
        path: "/openReg",
        query: {
          s: collection,
          e: str2,
        },
      });
      // db.collection("OA_UAT/ClientList/Clients")
      //   .doc(this.clientID)
      //   .collection("Events")
      //   .doc(eventId)
      //   .get()
      //   .then(function(doc) {
      //     if (doc.exists) {
      //       vm.goToEvent(doc);
      //     }
      //   })
      //   .catch(error => {
      //     alert(error);
      //     // console.log("Error getting documents: ", error);
      //   });
      //router.push({
      //  name: "Lobby",
      //  params: {
      //    sid: events.id,
      //    eCol: events.EventCollectionName,
      //    ename: events.Name,
      //    estartdt: events.EventStartDate,
      //    eenddt: events.EventEndDate,
      //    tzone: events.EventTimezone
      //  }
      //});
    },
    formatDate: function (seconds) {
      var dateString = "";
      //  alert(seconds);
      // if (seconds == 1594125120) {
      //   debugger;
      // }
      try {
        var dt = new Date(seconds.seconds * 1000);
        const monthNamesShort = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }
        dateString +=
          dt.getDate() +
          " " +
          monthNamesShort[dt.getMonth()] +
          " " +
          dt.getHours() +
          ":" +
          minutes;
        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    /* ,
    computed: {
      BannerURL() {
        // debugger;
        // var obj = JSON.parse(window.localStorage.getItem("my-app"));
        // return obj.branding[0].banner;
        //  db.collection("OA_UAT")
        //         .doc("ClientList")
        //         .collection("Clients")
        //         .where("CustomDomain", "==", this.result)
        //         .get()
        //         .then(querySnapshot => {
        //           querySnapshot.forEach(doc => {
        //           });
        //         });
      },
      pageBg() {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        return obj.EventBranding[0].bg2;
      }
    }*/
  },
};
</script>